import { NewTouMainPage } from './../../../apps/gamer/pages/new-tou/new-tou-main';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { ChangeDetectorRef, Component, ElementRef, ViewChild, ViewChildren } from '@angular/core';
import { TranslateDefaultParser, TranslateService } from '@ngx-translate/core';
import { IonContent, IonInfiniteScroll, NavController, Platform, ModalController, ActionSheetController, ToastController, LoadingController } from '@ionic/angular';
import { timer } from 'rxjs';
import { ScrollHideConfig } from '../../../../directives/scroll-hide';
import { CategoriesProvider, CategoryModel } from '../../../../providers/categories/categories';
import { ConfigProvider } from '../../../../providers/config/config';
import { EventListModel, EventProvider, EventSearchModel, EventComplex, EventTievts, EventDetailsModel, Pager } from '../../../../providers/event/event';
import { GoogleMapsProvider } from '../../../../providers/google-maps/google-maps';
import { LoaderProvider } from '../../../../providers/loader/loader';
import { PublicProfileModel, UserProvider } from '../../../../providers/user/user';
import { ValueModel, ValueProvider } from '../../../../providers/value/value';
import { SessionProvider } from '../../../../providers/session/session';
import { NearbyMainResolver, NearbyMainViewModel } from '../../../nearby/main/nearby-main-resolver';
import { TutorialProvider } from '../../../../providers/tutorial/tutorial';
import { NewsRespond, NewsController } from '../../../../providers/news/news-contoller';
import { Storage } from '@ionic/storage';
import { DeeplinkProvider } from '../../../../providers/deeplink/deeplink';
import { AppDetectorProvider } from '../../../../providers/detector/detector';
import { PrivateProfilePage } from '../../../me/settings/private-profile/private-profile';
import { HttpClient, HttpClientModule, HttpHeaders, HttpParams } from '@angular/common/http';
import { Calendar } from '@awesome-cordova-plugins/calendar/ngx';//'@ionic-native/calendar/ngx';
// import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { Deeplinks } from '@awesome-cordova-plugins/deeplinks/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { DateFormatModel, SettingsProvider } from '../../../../providers/settings/settings';
import { Subscription } from 'rxjs';
import { TournamentService } from '../../../apps/gamer/services/tournament.service';
import { BarcodeScanner, BarcodeScanResult } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { EventsLauncherService } from '../../../../providers/events-launcher.service';
import { DarkMode, ThemeMode } from '../../../../providers/dark-mode/dark-mode';
import { NavigationEnd, Router } from '@angular/router';
import { NavigationService } from 'src/providers/navigation/navigation.service';
import { EventsBlockWithContainersComponent } from '../../../../components/events-block-with-containers/events-block-with-containers';
declare var cordova: any;
declare let Stripe;

@Component({
  selector: 'page-event-search',
  templateUrl: 'event-search.html',
  styleUrls: ['./event-search.scss']
})
export class EventSearchPage {
  @ViewChild('searchform') searchform: any;
  @ViewChild('eventSearchContent') eventSearchContent: IonContent;
  eventCategories: CategoryModel[];
  eventRanges: ValueModel[];
  eventDistances: ValueModel[];
  eventDates: ValueModel[];
  events: EventDetailsModel[] = [];
  searched: boolean = false;
  timerClosest: any; 
  $loginSub = null;
  $logoutSub = null;
  $planSub = null;
  sportTypes = [
    {
      id: "RunningEvents",
      // name: this.translate.instant('CATEGORY_RUN'),
      name: 'CATEGORY_RUN',
      uniqueName: "RunningEvents"
    },
    {
      id: "RoadBikeEvents",
      name: "CATEGORY_ROADBIKE_EVT",
      // name: this.translate.instant("CATEGORY_ROADBIKE_EVT"),//"Roadbike",
      uniqueName: "RoadBikeEvents"
    },
    {
      id: "TriathlonEvents",
      name: "CATEGORY_TRI",
      // name: this.translate.instant("CATEGORY_TRI"),//"Triathlon",
      uniqueName: "TriathlonEvents"
    }
  ];

  activeSportType = null;

  searchModel: EventSearchModel = {
    cid: -1,
    dur: '',
    str: '',
    umkr: '',
    zip: -1,
    searchQuery:''
  };
  savedSearch: EventSearchModel;
  savedSearchPager: Pager;
  headerScrollConfig: ScrollHideConfig = { cssProperty: 'top', maxValue: 100 };
  isSearchFormVisible: boolean = true;
  addNewEvent: boolean = false;
  city: string = '';
  newsTab: boolean = false;

  @ViewChild(IonContent)
  content: IonContent;
  @ViewChildren('resultList')
  resultList: any;
  @ViewChild(EventsBlockWithContainersComponent)
  eventsBlockWithContainers: EventsBlockWithContainersComponent;

  showMySport: boolean = false;

  clientSpecific: boolean = false;
  vivawestClient: boolean = false;
  hellaClient: boolean = false;
  postbonnClient: boolean = false;
  spooortsApp: boolean = false;
  thurnauApp: boolean = false;

  CATEGORIES_PER_PAGE = 4;
  EVENTS_PER_PAGE = 10;
  currentPage = Array(this.CATEGORIES_PER_PAGE).fill(0);
  eventsComplex: EventComplex[] = [];
  newMenu: boolean = false;
  buttonMainGPS: boolean = false;
  mainColor: string = "white";
  openDetails: boolean = false;

  // UI
  // the variable is served as the switch for main background picture layout (gradient)
  // true - to show / false - to hide
  picLayout: boolean = true;
  isAccountAllowed: boolean = true;
  updater: boolean = true;

  // application id, data taken from config
  appId: string = "";

  FIRST_LAYER: boolean = false;
  SECOND_LAYER: boolean = false;
  THIRD_LAYER: boolean = false;
  SEARCH_LAYER: boolean = false;

  isBrowser: boolean = false;

  clientNextEvent = {
    sec: -1,
    min: -1,
    hour: -1,
    day: -1,
    name: ''
  };

  //trees
  treesCounter = {
    millions: "000",
    thousands: "000",
    hundreds: "000"
  }

  // For testing purposes
  test: boolean = false;
  pipeDateFormat = 'dd.MM.yyyy';
  changeDateFormatSubject = null;
  //
  constructor(
    public navCtrl: NavController,
    public categoriesService: CategoriesProvider,
    public valueService: ValueProvider,
    public eventService: EventProvider,
    public userService: UserProvider,
    public router:Router,
    public translate: TranslateService,
    public loadingCtrl: LoadingController,
    public viewCtrl: ModalController,
    public geoLocation: Geolocation,
    public googleService: GoogleMapsProvider,
    public detector: ChangeDetectorRef,
    private config: ConfigProvider,
    public sessionService: SessionProvider,
    private nearbyMainResolver: NearbyMainResolver,
    private eventProvider: EventProvider,
    private tutorialProvider: TutorialProvider,
    private actionSheetCtrl: ActionSheetController,
    private storageService: Storage,
    private deeplink: DeeplinkProvider,
    private platform: Platform,
    private categoryService: CategoriesProvider,
    private http: HttpClient,
    private settingsService: SettingsProvider,
    // private iab: InAppBrowser,
    private deeplinks: Deeplinks,
    private sharer: SocialSharing,
    private qrScanner: BarcodeScanner,
    private gs: TournamentService,
    private toastCtrl: ToastController,
    public eventsLauncherService: EventsLauncherService,
    public appDetector: AppDetectorProvider,
    private darkModeService:DarkMode,
    private navService:NavigationService
  ) {
    // @ts-ignore
    window.evS = this;
    new Promise(async (resolve, reject) => {
      this.settingsService.getActiveDateFormat().then(dateFormat => {
        this.pipeDateFormat = dateFormat.pipeFormat;
      });
      this.showMySport = (await this.config.config).showHide.mysport;
      this.addNewEvent = (await this.config.config).showHide.addNewEvent;
      this.clientSpecific = this.searched = (await this.config.config).showHide.clientEventSearch;
        this.appId = (await this.config.config).appId;
        this.newsTab  = (await this.config.config).showHide.tabsNews;
        this.isBrowser = (await this.config.config).platform.browser;
        this.buttonMainGPS = (await this.config.config).showHide.buttonMainGPS;
        this.mainColor = (await this.config.config).theme.color;

      // this.config.config.then(config=>{
      //   this.showMySport = config.showHide.mysport;
      //   this.addNewEvent = config.showHide.addNewEvent;
      //   this.clientSpecific = this.searched = config.showHide.clientEventSearch;
      //   this.appId = config.appId;
      //   this.newsTab  = config.showHide.tabsNews;
      //   this.isBrowser = config.platform.browser;
      //   this.buttonMainGPS = config.showHide.buttonMainGPS;
      //   this.mainColor = config.theme.color;
      //   console.log('config.showHide.clientEventSearch', config.showHide.clientEventSearch)
      // })
      console.log('this.showMySport', this.showMySport)
      console.log('this.searched', this.searched)

      this.vivawestClient = (this.appId.toLowerCase().includes('vivawest')) ? true : false;
      this.hellaClient = (this.appId.toLowerCase().includes('hella')) ? true : false;
      this.postbonnClient = (this.appId.toLowerCase().includes('postbonn')) ? true : false;
      this.spooortsApp = (this.appId.toLowerCase().includes('event')) ? true : false;
      this.thurnauApp = (this.appId.toLowerCase().includes('thurnau')) ? true : false;
      this.isAccountAllowed = (this.hellaClient) ? false : true;
      this.activeSportType = this.sportTypes[0];
      this.eventService.activeEventType = this.activeSportType.id;
      console.log('this.deeplink.getCurrentRequest(): ' + this.deeplink.getCurrentRequest());
      // this.buttonMainGPS = (await this.config.config).showHide.buttonMainGPS;
      // this.mainColor = (await this.config.config).theme.color;
      this.deeplink.onRequestEventSubject().subscribe((enaOrig) => {
        this.onSecondLayerPressed(enaOrig);
      });
      this.initSubs();
      if (this.clientSpecific) {
        this.initClient();
      } else {
        this.initBase();
      }
      if (this.deeplink.getCurrentRequest().includes('thurnau')) {
        // (this.app.getRootNav() as NavController).getActiveChildNav().select(1);
        this.navCtrl.navigateForward('/tab1');
      }

    setTimeout(() => {
        this.userService.checkLoged();
      }, 10000);
    });
    console.log('this.activeSportType ', this.activeSportType )
  }
  
  onLogin() {
    // (this.app.getRootNav() as NavController).push(LoginPage);
    this.navCtrl.navigateForward('/auth/login');
  }

  onNewTournament() {
    if (!this.sessionService.isLoged) {
      this.onLogin();
      localStorage.setItem("openNewPage", "1");
    } else {
      // (this.app.getRootNav() as NavController).push(this.getNewEventPage());
      this.navCtrl.navigateForward(this.getNewEventPage())
    }
  }

  getNewEventPage() {
    if (this.appDetector.isLeaderBoardApp()) {
      return '/event/create/create-tabs'
      // return EventCreateTabsPage;
    } else if (this.appDetector.isTournamentApp()) {
      // return NewTouMainPage;
      return '/gamer/new-tou'
    }
    return ''
  }

  ngOnInit() {
    let mode = JSON.parse(localStorage.getItem('darkMode') || `"${ThemeMode.LightMode}"`) as ThemeMode;
    this.darkModeService.setThemeMode(mode);
    console.log('mode ', mode)
    console.log(this.appDetector.isEventsApp())
    if(this.appDetector.isEventsApp()){
      let isDark = (mode === ThemeMode.DarkMode);
      let body = <HTMLElement>document.querySelector('body');
      if (isDark && !body.classList.contains(ThemeMode.DarkMode)) {
        body.classList.add(ThemeMode.DarkMode);
      } 
    }  
    this.changeDateFormatSubject = this.settingsService.dateFormatChangeSubject$.subscribe((dateFormat: DateFormatModel) => {
      this.pipeDateFormat = dateFormat.pipeFormat;
    });
    if (!this.$loginSub) {
      this.$loginSub = this.sessionService.onRequestLoggedIn().subscribe(() => {
        this.eventsLauncherService.isLauncherPage = false;
        if (this.clientSpecific) {
          this.initClient();
        } else {
          this.initBase();
        }
        if (!!localStorage.getItem("openNewPage")) {
          setTimeout(() => {
            this.navCtrl.navigateForward(this.getNewEventPage());
            // (this.app.getRootNav() as NavController).push(this.getNewEventPage());
          }, 500);
          localStorage.removeItem("openNewPage");
        }
      });
    }

    if (!this.$logoutSub) {
      this.$logoutSub = this.sessionService.onRequestLogout().subscribe(() => {
        this.eventsLauncherService.isLauncherPage = true;
      });
    }

    if (!this.$planSub) {
      this.$planSub = this.gs.$planListChangeSub.subscribe(() => {
        this.eventsLauncherService.isLauncherPage = false;
      });
    }
  }

  ngOnDestroy() {
    if (this.$loginSub) {
      this.$loginSub.unsubscribe();
      this.$loginSub = null;
    }
    if (this.$planSub) {
      this.$planSub.unsubscribe();
      this.$planSub = null;
    }
    if (this.changeDateFormatSubject) {
      this.changeDateFormatSubject.unsubscribe();
      this.changeDateFormatSubject = null;
    }
  }
  ontest2() {
    let body = <HTMLElement>document.getElementsByTagName("body")[0];
    body.style.backgroundColor = "white";
  }

  // show() {
  //   this.qrScanner.show().then((info) => {
  //     console.log('info: ' + info);
  //   });
  // }

  scan() {
    this.qrScanner.scan().then(barcodeData => {
      if (!barcodeData.cancelled) {
        this.showMessage(barcodeData.text);
      } else {
        console.log('Scan cancelled');
      }
    }).catch(err => {
      console.error('Scan failed', err);
    });
  }

  async showMessage(message: string) {
    let toast = await this.toastCtrl.create({
      message: message,
      duration: 5000,
      position: 'top'
    });
    toast.present();
  }

  initSubs() {
    if (this.appDetector.isEventsApp()) {
      this.platform.ready().then(async () => {

        this.sessionService.onRequestPageLogin().subscribe(() => {
          this.showLogin();
        });

        this.sessionService.onRequestPageProfileEdit().subscribe(async() => {
          // let l = (this.app.getRootNav() as NavController).getViews();
          let l=[] 
          this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
              l.push(event.urlAfterRedirects);
            }
          });
          if (l.find(x => x.component === PrivateProfilePage)) return;


          let loader = await this.loadingCtrl.create({
            message:this.translate.instant('GLOBAL_LOADING')
          });
          loader.present();
          Promise.all([
            this.valueService.getProfileTitles(),
            this.valueService.getProfileTypes(),
            this.valueService.getCountries(),
            this.categoryService.getEventCategoires(),
            this.valueService.getProfileBackgrounds()
          ]).then(values => {
            const targetUrl = '/me/settings/private-profile'
            if (!this.router.url.includes(targetUrl)) {
              this.navCtrl.navigateForward(targetUrl, {state:{
                 data: {
                  titles: values[0],
                  types: values[1],
                  countries: values[2],
                  categories: values[3],
                  photos: [],
                  backgrounds: values[4],
                  profile: this.sessionService.profile
                }
              }})
              .then(() => {
                loader.dismiss()
              });
            }
          });
        });

        let loader = await this.loadingCtrl.create();
        Promise.all([this.categoryService.getAllCategories(), this.userService.checkLoged()]).then(() => {
          loader.dismiss();
        });
      });
    }
  }

  onSecondBackMenu() {
    if (this.appDetector.isHellaApp() || this.appDetector.isForestApp()) {
      this.hellaClient = !this.hellaClient;
      this.hellaClient = !this.hellaClient;
      if (this.timerClosest) {
        this.timerClosest.unsubscribe();
        this.timerClosest = null;
        this.detector.detectChanges();
      }
      this.updater = false;
      setTimeout(() => {
        this.updater = true;
      }, 100);
      this.initClient();
    } else {
      if (this.timerClosest) {
        this.timerClosest.unsubscribe();
        this.timerClosest = null;
        this.detector.detectChanges();
      }
      this.updater = false;
      setTimeout(() => {
        this.updater = true;
      }, 100);
      this.openDetails = false;
      this.SEARCH_LAYER = this.SECOND_LAYER = this.THIRD_LAYER = this.searched = false;
      this.FIRST_LAYER = true;
    }
  }

  async onBackMenu() {
    this.updater = false;
    setTimeout(() => {
      this.updater = true;
    }, 100);
    if (this.SEARCH_LAYER) {
      let loader = await this.loadingCtrl.create({message: this.translate.instant('GLOBAL_LOADING')});
      loader.present()
      this.SECOND_LAYER = this.THIRD_LAYER = this.SEARCH_LAYER = false;
      this.FIRST_LAYER = true;
      this.searched = false;
      setTimeout(()=>{
        loader.dismiss()
      }, 3000)
    }
    else if (this.SECOND_LAYER || this.eventArea.toUpperCase().includes('VIR')) {
      this.FIRST_LAYER = true;
      this.SECOND_LAYER = this.THIRD_LAYER = false;
    } else if (this.THIRD_LAYER) {
      this.SECOND_LAYER = true;
      this.FIRST_LAYER = this.THIRD_LAYER = false;
    }
  }

  onOpenLastDetailsPage(complex: EventComplex) {
    this.openEventDetails(complex.event[complex.event.length - 1]);
  }

  async onSecondLayerPressed(name) {
    let loader = await this.loadingCtrl.create();
    // loader.present();
    this.eventService.getClientEventsWithEnaOrig(name).then(events => {

      if (!events) { 
        loader.dismiss(); 
        return; 
      }
      this.hellaClient = !this.hellaClient;
      this.hellaClient = !this.hellaClient;
      this.openDetails = true;
      this.events = events.reverse();
      this.SEARCH_LAYER = true;
      loader.dismiss();
      if (this.timerClosest) {
        this.timerClosest.unsubscribe();
        this.timerClosest = null;
        this.detector.detectChanges();
      }
      this.updater = false;
      setTimeout(() => {
        this.updater = true;
      }, 100);
      this.initClientTimer();

    }).catch(err => loader.dismiss());
  }

  async onSecondLayerForward(event) {
    let loader = await this.loadingCtrl.create();
    loader.present();
    this.eventService.getEventSecondLayer(event.eventName.replaceAll('%20', ' '), event.ort, event.dateFormatted, event.cid).then(events => {
      this.openDetails = true;
      this.events = events.reverse();
      this.SEARCH_LAYER = true;
      loader.dismiss();
      this.updater = false;
      setTimeout(() => {
        this.updater = true;
      }, 100);
      this.initClientTimer();

    })
    .catch(err => loader.dismiss());
  }

  initClient() {
    this.translate.get('GLOBAL_LOADING').subscribe(async() => {
      let loader = await this.loadingCtrl.create();
      loader.present();
      this.newMenu = false;
      this.openDetails = false;
      this.picLayout = (this.appId.toUpperCase().includes("FRANKFURT") ? false : true);
      let getClientEvents = (this.hellaClient || this.spooortsApp) ? 'udevts' : "";

      this.eventService.getTrees().then(result => this.convertTrees(result));
      getClientEvents.length === 0 ? this.getClientEvents(loader) : this.getClientEventsDistinct(loader);
    });
  }

  getClientEvents(loader) {
    this.eventService.getClientEvents().then(async(events) => {
      console.log('clientEvts', events)
      let safeEvents = (events || []);
      this.events = safeEvents.reverse();
      this.SEARCH_LAYER = true;
      if (this.timerClosest) {
        this.timerClosest.unsubscribe();
        this.timerClosest = null;
        this.detector.detectChanges();
      }
      loader.dismiss();
      this.initClientTimer();
    }).catch(err => {
      console.error(err);
      loader.dismiss();
    });
  }

  getClientEventsDistinct(loader) {
    this.eventService.getClientEventsDistinct().then(events => {
      let safeEvents = (events || []);
      this.events = safeEvents.reverse();
      this.SEARCH_LAYER = true;
      if (this.timerClosest) {
        this.timerClosest.unsubscribe();
        this.timerClosest = null;
        this.detector.detectChanges();
      }
      loader.dismiss();
      this.initClientTimer();
    }).catch(err => {
      console.error(err);
      loader.dismiss();
    });
  }
  convertTrees(t) {
    if (!t) return;
    let arr = (t.treesPlanted + "").split('');
    let prefix = Array(9 - arr.length).fill(0).join('');

    let formatted = prefix + arr.join('');
    this.treesCounter.millions = formatted[0] + formatted[1] + formatted[2];
    this.treesCounter.thousands = formatted[3] + formatted[4] + formatted[5];
    this.treesCounter.hundreds = formatted[6] + formatted[7] + formatted[8];
    // millions = trees.treesPlaned 
  }

  getEventDay() {
    return (this.clientNextEvent.day >= 0) ? this.clientNextEvent.day : '00';
  }

  getEventHour() {
    return (this.clientNextEvent.hour >= 0) ? this.clientNextEvent.hour : '00';
  }

  getEventMin() {
    return (this.clientNextEvent.min >= 0) ? this.clientNextEvent.min : '00';
  }

  getEventSec() {
    return (this.clientNextEvent.sec >= 0) ? this.clientNextEvent.sec : '00';
  }

  async initClientTimer() {
    let current = new Date().getTime();
    let closest: EventListModel = null;

    this.updater = false;
    setTimeout(() => {
      this.updater = true;
    }, 100);

    this.events.sort((a, b) => {
      return a.date > b.date ? 1 : -1;
    });

    if (this.events.length > 0)
      closest = this.events[0];

    if (closest) {
      let config = await this.config.getConfigFile();

      this.timerClosest = timer(0, 999).subscribe(v => {
        current = new Date().getTime();
        let calc = (closest.date - current) / 1000;

        this.clientNextEvent = {
          sec: Math.floor(calc % 60),
          min: Math.floor((calc % 3600) / 60),
          hour: Math.floor((calc % 86400) / 3600),
          day: Math.floor(calc / 86400),
          name: closest.name || config.client.name
        };
        this.detector.detectChanges();

      });
    }
  }

  nearbyEvents: NearbyMainViewModel;

  async openEventDetails(_event) {
    let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    /*
    // if it is spooorts app then we don't use evt to get the ID, id is integrated into TitleEventPOJO
    */

    if (this.spooortsApp) {
      this.eventService.getEventDetails(_event.id).then((event: EventDetailsModel) => {
        if (event.name.length < 1) {
          this.openEventDetails(_event);
          loader.dismiss();
        } else {
          this.navCtrl.navigateForward('/tab1/event/details/tabs', {state:{event: event, dateFormatted: _event.dateFormatted}})
          .then(() =>{
            loader.dismiss()
          });
          // (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event, dateFormatted: _event.dateFormatted }).then(() => loader.dismiss());
        }
      })
      .catch(err => loader.dismiss());
    } else {
      this.eventService.getEventId(_event.eventName, _event.ort, _event.dateFormatted, _event.cid).then(id => {
        if (id == -1) { 
          loader.dismiss(); 
          return; 
        };

        this.eventService.getEventDetails(id).then((event: EventDetailsModel) => {
          if (event.name.length < 1) {
            this.openEventDetails(_event);
            loader.dismiss();
          } else {
            this.navCtrl.navigateForward('/tab1/event/details/tabs', {state:{event: event, dateFormatted: _event.dateFormatted}})
            .then(() =>{
              loader.dismiss();
            });
            // (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event, dateFormatted: _event.dateFormatted }).then(() => loader.dismiss());
          }
        })
        .catch(err => loader.dismiss());
      })
    }
  }

  getEventStatus(event: EventTievts) {
    let status = event.eventStatus;
    if (status.toUpperCase().includes("CANCELLED")) return this.translate.instant('EVENT_CANCELLED');
    else if (status.toUpperCase().includes("NOT_CONFIRMED")) return this.translate.instant('NOT_CONFIRMED');
    else return "";
  }

  async openTracking() {
    if (!this.nearbyEvents) {
      let loading = await this.loadingCtrl.create({
        message: this.translate.instant('GLOBAL_LOADING')
      });
      loading.present();
      let ids = [];
      this.events.forEach(eventitem => ids.push(eventitem.id + ''));
      this.nearbyMainResolver.doResolve(this.events).then(nearbyEvents => {
        this.nearbyEvents = nearbyEvents;
        this.navCtrl.navigateForward('/nearby', {state:{events: nearbyEvents}})
        .then(() =>{
          loading.dismiss()
        });
        // (this.app.getRootNav() as NavController).push(NearbyMapPage, { events: nearbyEvents }).then(() => loading.dismiss());
      });
    } else {
      // (this.app.getRootNav() as NavController).push(NearbyMapPage, { events: this.nearbyEvents });
      this.navCtrl.navigateForward('/nearby', {state:{events: this.nearbyEvents}})
      .then(()=>{
      })
    }
  }

  async initBase() {
    let loader = await this.loadingCtrl.create({
      message: this.translate.instant('GLOBAL_LOADING')
    });
    loader.present();

    this.searchModel.page = null;
    this.searchModel.limit = null;
    this.searchModel.start = null;

    this.newMenu = true;
    this.FIRST_LAYER = true;

    this.categoriesService.getEventCategoires().then(async dataCategory => {
      let virtualOnly = (this.appDetector.isEventsApp()) ? false : true;

      this.eventProvider.getEventComplex("Events", this.searchModel, virtualOnly).then((data: EventComplex[]) => {
        let ids = data[0]?.event.map(x => x.id);

        // this.eventService.getNearbyEvents(ids).then((events) => {
        //   console.log('events with maps: ', events);

        // });

        this.savedSearchPager = {
          limit: this.searchModel.limit,
          page: this.searchModel.page,
          start: this.searchModel.start
        }
        this.eventsComplex = data;
        loader.dismiss();
      });
      this.eventCategories = dataCategory;
      const selectedCategory = this.eventCategories.find(evt=>this.translate.instant(evt.uniqueName) === this.activeSportType.uniqueName);
      console.log('selectedCategory', selectedCategory)
      await this.onCategorySelected(selectedCategory.id);
       this.searchModel.cid = selectedCategory.id;
    });
 
    // if (!this.isBrowser) {
    //   this.geoLocation.getCurrentPosition().then(position => {
    //     this.googleService.getGoogle().then(google => {
    //       var geocoder = new google.maps.Geocoder();
    //       var geolocate = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
    //       var me = this;
    //       geocoder.geocode({ latLng: geolocate }, (results, status) => {
    //         if (status == google.maps.GeocoderStatus.OK) {
    //           var result;
    //           if (results.length > 1) {
    //             result = results[1];
    //           } else {
    //             result = results[0];
    //           }

    //           if (me.searchModel.zip === '') {
    //             me.searchModel.zip = result.address_components[result.address_components.length - 1].long_name;
    //             me.city = result.address_components[2].long_name;
    //             me.detector.detectChanges();
    //           }
    //         }
    //       });
    //     });
    //     // this.onSearch(null);
    //   });
    // }
  }

  reload = true;
  onSportTypeChange(event:any) {
    if (this.activeSportType.id.includes("Events")) {
      this.eventService.activeEventType = this.activeSportType.id;
    }else{
      this.eventService.activeEventType = this.activeSportType.id + "Events";
    }
    this.reload = false;
    setTimeout(() => {
      this.reload = true;
    });
    this.initBase();
  }
  
  arrayOf(events: EventTievts[], i: number): EventTievts[] {
    if (events.length == 0)
      return null;

    if (this.isLastPage(events.length, i)) {
      return events.slice(this.currentPage[i] * this.EVENTS_PER_PAGE, (this.currentPage[i] * this.EVENTS_PER_PAGE) + (events.length % this.EVENTS_PER_PAGE));
    }
    return events.slice(this.currentPage[i] * this.EVENTS_PER_PAGE, (this.currentPage[i] + 1) * this.EVENTS_PER_PAGE);
  }

  getAllEvents(i: number) {
    return this.eventsComplex[i].event.slice(0, 10);
  }

  eventTypePass: string;

  getEventType() {
    return this.eventTypePass || this.activeSportType.id;
  }

  onMorePress(event: EventComplex) {
    this.eventTypePass = event.category;
    this.FIRST_LAYER = false;
    this.SECOND_LAYER = true;
    // (this.app.getRootNav() as NavController).push(ResultCategoryPage, { eventType: event.category });
  }

  eventArea: string;

  getEventArea() {
    console.log(this.eventArea);
    return this.eventArea;
  }

  getEventComplex() {
    return this.eventsComplex.slice(0, this.CATEGORIES_PER_PAGE);
  }

  onLoadThirdLayer(area) {
    this.eventArea = area;
    this.SECOND_LAYER = false;
    this.THIRD_LAYER = true;
  }

  onMoreVirtualEvents(complex: EventComplex) {
    this.eventTypePass = complex.category;
    this.eventArea = "virtual";

    this.FIRST_LAYER = false;
    this.SECOND_LAYER = false;
    this.THIRD_LAYER = true;
  }

  isFirstPage(i: number): boolean {
    return (this.currentPage[i] == 0) ? true : false;
  }

  isLastPage(n: number, i: number): boolean {
    return ((this.currentPage[i] + 1) > (n / this.EVENTS_PER_PAGE)) ? true : false;
  }

  nextPage(i: number) {
    this.currentPage[i]++;
  }

  prevPage(i: number) {
    this.currentPage[i]--;
  }

  public isLoged(): boolean {
    return this.sessionService.isLoged;
  }

  public profileImage(): string {
    return this.sessionService.profile.profilePicLink || 'assets/imgs/default-image-32@1x.png';
  }

  public scrollIntoView(view: HTMLElement) {
    if (view) {
      view.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  expandForm() {
    this.isSearchFormVisible = !this.isSearchFormVisible;
  }

  // onScroll(event: ScrollEvent) { }
  // async ngAfterViewInit() {
  //   this.showMySport = (await this.config.config).showHide.mysport;
  // }
  onScroll(event: any) { //CustomEvent
    const scrollTop = event.detail.scrollTop;
    console.log('ScrollTop:', scrollTop);
  }

  loadNextPage(event: any) {
    const infiniteScroll = event.target as IonInfiniteScroll;
    if (typeof this.savedSearch === "undefined") {
      this.savedSearch = {
        page: null,
        cid: -1,
        dur: '',
        str: '',
        umkr: '',
        zip: -1,
        searchQuery:''
      }
    }
    this.eventService.getEventsBySearch(this.savedSearch).then(data => {
      this.events = this.events.concat(data);
      infiniteScroll.complete();
    });
  }

  loadNextSportsPage(event: IonInfiniteScroll, i: number) {
    this.eventService.getEventComplex("Events", this.savedSearchPager, false).then((data: EventComplex[]) => {

      let arr = Object.assign([], data[i].event);
      this.eventsComplex[i].event = this.eventsComplex[i].event.concat(data[i].event);
      event.complete();
    });
  }

  public clearLayers() {
    this.FIRST_LAYER = false;
    this.SECOND_LAYER = false;
    this.THIRD_LAYER = false;
  }

  public async onSearch(element: HTMLElement) {
    // if (this.searchModel.zip.length === 5 || this.searchModel.zip.length === 0) {
    const zip = Number(this.searchModel.searchQuery)
    if(!Number.isNaN(zip)){
      this.searchModel.zip = Number(this.searchModel.searchQuery);
      this.searchModel.searchQuery = '';
    }else{
      this.searchModel.zip = -1
    }
    if (this.searchModel.zip>0 || this.searchModel.searchQuery.length>0) {

      this.clearLayers();
      this.searched = true;

      let loader = await this.loadingCtrl.create({
        message: this.translate.instant('GLOBAL_LOADING')
      });
      loader.present();
      this.searchModel.page = null;
      this.searchModel.limit = null;
      this.searchModel.start = null;
      this.eventService.getEventsBySearch(this.searchModel).then(data => {
        console.log('getEventsBySearch: ');
        ///TODO dirty copy
        this.savedSearch = {
          cid: this.searchModel.cid,
          dur: this.searchModel.dur,
          str: this.searchModel.str,
          umkr: this.searchModel.umkr,
          zip: this.searchModel.zip,
          limit: this.searchModel.limit,
          page: this.searchModel.page,
          start: this.searchModel.start,
          searchQuery: this.searchModel.searchQuery
        };

        this.events = data;
        this.SEARCH_LAYER = true;

        loader.dismiss().then(() => {
          if (element)
            this.scrollIntoView(this.resultList.first.nativeElement);
        });
      });
    }
  }

  ionViewWillEnter() {
    console.log('[event-search.ts] will enter');
    // if (NewsController.getInstance().isAllowed)
      // this.checkNews();
    if (this.sessionService.isLoged) {
      this.eventsLauncherService.isLauncherPage = false;
    }
  }

  ionViewWillLeave() {
    console.log('[event-search.ts] will leave');
  }

  ionViewDidEnter() {
    console.log('[event-search.ts] did load');
    if (this.appDetector.isEventsApp() && !this.searched && this.reload && this.eventsBlockWithContainers) {
      this.eventsBlockWithContainers.initLangAndEventByLang();
    }
  }
  ionViewDidLeave() {
    // this.loadingCtrl.dismiss();
  }

  async checkNews() {
    if (this.appDetector.isForestApp()) return;


    let loader = await this.loadingCtrl.create({
      message: ""
    });
    loader.present();

    if (!this.newsTab) { 
      loader.dismiss(); 
      return; 
    }

    NewsController.getInstance().getNews().then((respond) => {
      this.tutorialProvider.isFirstRun().then(status => {
        console.log('Load TUTORIALS')
        if (!status) {
          if (respond.update) {
            if (respond.type.includes("DHL")) {
              this.userService.checkLoged().then(logged => {

                if (logged && this.sessionService.profile.clubName) {
                  if (this.sessionService.profile.clubName.includes("DHL"))
                    this.presentNewsActionSheet(respond);
                }
                else
                  return;
              });
            } else {
              this.presentNewsActionSheet(respond);
            }
          }
        } else {

          this.storageService.remove('news-general').then(() => {
            this.storageService.remove('news-dhl').then(() => {
              this.tutorialProvider.setTutorialDone();
            })
          });
        }
        loader.dismiss();
      })
    });
  }

  async presentNewsActionSheet(respond: NewsRespond) {
    if (respond.type.includes("DHL") && !this.appId.includes("postbonn")) {
      return;
    }

    let actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('NEW_NEWS'),
      buttons: [
        {
          text: 'Ok',
          handler: () => {
            if (respond.type.includes("DHL")) {
              if (this.sessionService.profile.clubName.includes("Deutsche Post DHL Group") && this.appId.includes("postbonn")) {
                // (this.app.getRootNav() as NavController).push(NotificationPage, { news: respond.data, dhl: true });
                this.navCtrl.navigateForward('/notification', {state:{ news: respond.data, dhl: true }})
              }
            }
            else {
              this.navCtrl.navigateForward('/tab1');
              // this.app.getRootNav().getActiveChildNav().select(1);
            }
          }
        },
        {
          text: this.translate.instant('GLOBAL_CANCEL'),
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });

    actionSheet.present();
  }

  public async onCategorySelected(event) {
    let loader = await this.loadingCtrl.create();

    loader.present().then(() => {
      Promise.all([
        this.valueService.getEventSeachRange(event),
        this.valueService.getEventSeachDistance(event),
        this.valueService.getEventSeachDate(event)
      ]).then(a => {
        this.eventRanges = a[0];
        this.eventDistances = a[1];
        this.eventDates = a[2];
        if (this.eventRanges && this.eventRanges.length > 0) {
          // this.searchModel.umkr = this.eventRanges[0].ident;
          this.searchModel.umkr = '';
        }
        if (this.eventDistances &&this.eventDistances.length > 0) {
          // this.searchModel.str = ''
          this.searchModel.str = this.eventDistances[0].ident;
        }
        if (this.eventDates && this.eventDates.length > 0) {
          this.searchModel.dur = this.eventDates[this.eventDates.length-1].ident;
        }
        loader.dismiss();
      });
    });
  }

  showAddEvent() {
    // this.app.getRootNav().push(EventCreateTabsPage);
    this.navCtrl.navigateForward('/event/create/create-tabs')
  }

  async showLogin() {
    console.log('SHOW LOGIN EVENT SEARCH')
    if (this.hellaClient) {
      // (this.app.getRootNav() as NavController).push(IdRegistrationPage);
      this.navCtrl.navigateForward('/auth/id-registration')
    } 
    else {
      let loader = await this.loadingCtrl.create({
        message: this.translate.instant('GLOBAL_LOADING')
      });
      loader.present();

      this.valueService.getProfileBackgrounds().then((backgrounds) => {

        NewsController.getInstance().isAllowed = false;
        // (this.app.getRootNav() as NavController)
        //   .push(MysportUserProfilePage, {
        //     data: { profile: this.sessionService.profile, backgrounds: backgrounds }
        //   })
        const locationPathes = this.router.url;
        if(!locationPathes.includes('/auth/login')){
          this.navCtrl.navigateForward('/tab2/me/mysport/user-profile',{state:{data: { profile: this.sessionService.profile, backgrounds: backgrounds }}})
            .then(()=>{
              loader.dismiss();
            })
        }else{
          loader.dismiss();
        }
      })
      // this.loadingCtrl.dismissAll();
    }
  }

  openMap() {
    this.navCtrl.navigateForward('/tab1/event/main/search-map',{state:{events: this.events}})
    // (this.app.getRootNav() as NavController).push(EventSearchMapPage, {
    //   events: this.events
    // });
  }

  async getElevation() {
    let url = "https://maps.googleapis.com/maps/api/elevation/json?locations=" + 51.503569 + "," + 6.5360324 + "&key=AIzaSyCNgApvfwUvCkVd-ZMleMaAAgw5vi_VnqI";
    var proxyUrl = 'https://cors.bridged.cc/',
      targetUrl = url
    return fetch(proxyUrl + targetUrl)
      .then(blob => blob.json())
      .then(data => {
        return data.results[0].elevation;
      })
      .catch(e => {
        if(e.status === 400 || e.status === 401){
          alert(e.error.message);
          return 0;
        }
        return -1
      });
    }

  async payGyropay() {

    console.log(window.location.href);

    let loader = await this.loadingCtrl.create({});
    loader.present();

    let params = {
      amount: 1 * 100,        //amount is in cents
      currency: "eur",
      paymentMethodType: "sofort"
    };

    let path = "pay?type=" + params.paymentMethodType + "&amount=" + params.amount + "&currency=" + params.currency;

    this.makeTestIntent(path).then((paymentClientIntent) => {
      console.log('paymentClientIntent: ', paymentClientIntent);
      this.confirmGiropay(paymentClientIntent);
      loader.dismiss();
    }).catch(err => {
      // this.onSuccess.emit(false);
      loader.dismiss();
    });
  }


  async confirmGiropay(clientSecret) {
    let stripePublish = Stripe('pk_test_51IefWZEfWOjwetWPxnBDPVmpHQHFnLVX9n8wWAind4TcD40lhE0FAl0EBahtcNkPk9XWkLnENMSoliSFCbub9T6Y00AQ7RZaWc');

    const {
      error: stripeError,
      paymentIntent,
    } = await stripePublish.confirmSofortPayment(clientSecret, {
      payment_method: {
        sofort: {
          country: 'DE',
        },
        billing_details: {
          name: "Slavik Spasibo",
          email: "test@test.com",
        },
      },
      return_url: window.location.href,
    });

    if (stripeError) {
      console.log(stripeError.message);
      return;
    }

    console.log(`Payment ${paymentIntent.status}: ${paymentIntent.id} `);
  }

  async makeTestIntent(path): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.http.get("http://localhost:8080/" + path, { responseType: "text" }).toPromise().then((response) => {
        let paymentClientIntent = JSON.parse(JSON.stringify(response));
        resolve(paymentClientIntent);
      }).catch((err) => {
        console.log(err);
        reject(err);
      })
    });
  }

  

  // //crop the image and draw it to the canvas
  cropImage(imagePath, newX, newY, newWidth, newHeight) {
    //create an image object from the path
    const originalImage = new Image();
    originalImage.src = imagePath;

    //initialize the canvas object
    const canvas = document.getElementById('canvas') as HTMLCanvasElement | null;
    const ctx = canvas.getContext('2d');

    //wait for the image to finish loading
    originalImage.addEventListener('load', function () {

      //set the canvas size to the new width and height
      canvas.width = newWidth;
      canvas.height = newHeight;

      //draw the image
      ctx.drawImage(originalImage, newX, newY, newWidth, newHeight, 0, 0, newWidth, newHeight);
    });
  }

  onLoginPage() {
    // (this.app.getRootNav() as NavController).push(LoginPage);
    this.navCtrl.navigateForward('/auth/login')
  }

  onRegisterPage() {
    this.navCtrl.navigateForward('/auth/registration')
    // (this.app.getRootNav() as NavController).push(RegistrationPage);
  }

  showNewEvent() {
    this.sessionService.getTokenAndNavigate(false, false).then(() => {
    // this.app.getRootNav().push(EventCreateTabsPage);
      this.navCtrl.navigateForward('/tab1/event/create/create-tabs')
    });
  }

  updateZip(event) {
    if (this.searchModel.zip>  0) {
      this.city = this.translate.instant('EVENT_SEARCH_EVERYWHERE');
    } else if (String(this.searchModel.zip).length === 5) {
      this.googleService.getGoogle().then(google => {
        var geocoder = new google.maps.Geocoder();

        var me = this;
        geocoder.geocode({ address: 'germany ' + me.searchModel.zip }, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            var result;
            if (results.length > 1) {
              result = results[1];
            } else {
              result = results[0];
            }

            //me.searchModel.zip = result.address_components[4].long_name;
            if (result.address_components[2]) {
              me.city = result.address_components[2].long_name;
              me.detector.detectChanges();
            }
          }
        });
      });
    }
  }


}
